import React, { useEffect, useState } from 'react';
import { Collapse, Icon } from 'antd';
import { Button, ColumnProps, Row, Table, Widget } from '@digital/ui';
import { dadosGeraisState, desabilitarAcoesState, ordemCompraIdState, reloadState } from '../atoms';
import { useRecoilState, useRecoilValue } from 'recoil';
import { getAtualizarAprovacaoContrato, getContratoHistoricoAprovacaoTotvs } from '@app/api/sas/ordemCompra';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import { ETipoContrato } from '@app/enums/ETipoContrato';
import { Visibility } from '@app/components';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';


interface Props {
    parteDoFluxo?: boolean;
}

const WidgetHistoricoAprovacoes = ({ parteDoFluxo = false }: Props) => {
    const [historicoAprovacoes, setHistoricoAprovacoes] = useState<any[]>([]);
    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const [reloadTabela, setReloadTabela] = useState(false);
    const [reload, setReload] = useRecoilState(reloadState);
    const [dadosGerais, setDadosGerais] = useRecoilState(dadosGeraisState);
    const desabilitarAcoes = useRecoilValue(desabilitarAcoesState);

    const ehAditivo = dadosGerais.tipo === ETipoDemanda.Aditivo;

    useEffect(() => {
        getContratoHistoricoAprovacaoTotvs(ordemCompraId)
            .then(data => {
                if (isObjNotEmpty(data)) {
                    setHistoricoAprovacoes(data || []);
                }
            });
    }, [ordemCompraId, reloadTabela]);

    const atualizarAprovacaoContrato = () => {
        getAtualizarAprovacaoContrato(ordemCompraId)
            .then((data) => {
                setReloadTabela(!reloadTabela);
                setReload(!reload);
            });
    };

    const ehPCS = () => {
        return dadosGerais && isObjNotEmpty(dadosGerais.modalidadeContratoTotvs)
            ? dadosGerais.modalidadeContratoTotvs.toLowerCase() == ETipoContrato.PCS
            : false;
    };

    const columnsInfoAprovacao: ColumnProps<any>[] = [
        {
            title: 'Aprovador',
            dataIndex: 'aprovador',
        },
        {
            title: 'Aprovador Alternativo',
            dataIndex: 'aprovadorAlternativo',
        },
        {
            title: 'Data Geração',
            dataIndex: 'dataGeracaoString',
        },
        {
            title: 'Data Aprovação',
            dataIndex: 'dataAprovacaoString',
        },
        {
            title: 'Situação',
            dataIndex: 'situacao',
        },
        {
            title: 'Rejeição',
            dataIndex: 'rejeicao',
        },
    ];

    const tipo = ehPCS() 
        ? ehAditivo 
            ? 'Aditivo PCS' 
            : 'PCS' 
        : 'Contrato';

    return (
        <>
            <Collapse
                bordered={false}
                defaultActiveKey="historicoAprovacoesCt"
                expandIcon={() => <Icon type="arrows-right_4" />}>
                <Collapse.Panel 
                    header={`Informações de Aprovação do ${tipo} no Totvs`} 
                    key="historicoAprovacoesCt" 
                    showArrow={!parteDoFluxo}
                >
                    <Widget
                        actions={[
                            <Visibility visible={desabilitarAcoes === false}>
                                <Button onClick={() => atualizarAprovacaoContrato()} type="primary" key="gerarContratoBtn" style={{ marginLeft: 10 }}>
                                    Atualizar
                                </Button>
                            </Visibility>
                        ]}
                    >
                        <Row>
                            <Table
                                style={{ paddingInline: '4px' }}
                                columns={columnsInfoAprovacao}
                                dataSource={historicoAprovacoes}
                                pagination={false}
                            />
                        </Row>
                    </Widget>
                </Collapse.Panel>
            </Collapse>
        </>
    );
};

export default WidgetHistoricoAprovacoes;